import React from 'react'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../UI/form/MyButton'
import { useDispatch } from 'react-redux'
import { useState } from 'react'
import { useEffect } from 'react'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import { editSupplyBillItem } from '../../../../../store/supplyBillSlice'
import { editSupplyBillItemContractAPI } from '../../../../../api/supply/supplyBillItemAPI'
import ContractSelectMain from '../../../../form/fields/ContractSelectMain'

const ChangeContractForm = ({ supplyBillItemBd, setOpen }) => {

    const dispatch = useDispatch()

    const [data, setData] = useState(
        supplyBillItemBd ? 
            {
                contractId: supplyBillItemBd.contractId,
            } 
        : {}
    ) // Дані з форми

    // console.log('data', data)
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()
        const dataForBd = getDataForBd()

        setError('')
        setLoading(true)

        editSupplyBillItemContractAPI(dataForBd).then(data => {
            if (data) {
                dispatch(editSupplyBillItem(data))
            }

            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const getDataForBd = () => {
        const dataForBd = {
            id: supplyBillItemBd.id,
            contractId: data.contractId,
        }

        return dataForBd
    }

  return (
    <div className='myFormSimple'>
        {
			formDataProductIsField('contractId', 'supplyBillItem') ?
				<ContractSelectMain
					required={formDataProductRequiredField('contractId', 'supplyBillItem')}
					setValidate={e => updateValidate(setValid, 'contractId', e)}
					setValueForm={e => setValueForm(setData, 'contractId', e)}
					forciblyValue={data && data.contractId ? data.contractId : ''}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default ChangeContractForm